import type { ReactNode } from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import { useLocation } from 'react-router';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import {
  ANY_SPORT_MARKET_AUCTIONS,
  ANY_SPORT_MARKET_MANAGER_SALES,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';
import { matchAnySportPath } from '@sorare/core/src/lib/routing/generateSportPath';

const messages = defineMessages({
  goToSecondary: {
    id: 'EmptyMarket.goToSecondary',
    defaultMessage: 'Go to secondary market',
  },
  goToPrimary: {
    id: 'EmptyMarket.goToPrimary',
    defaultMessage: 'Go to primary market',
  },
});

const CTA = styled(Button)`
  margin-top: var(--double-unit);
`;

type Props = {
  ctaMessage?: ReactNode;
};

export const EmptyMarket = ({ ctaMessage }: Props) => {
  const { isIosApp, isMarketAuthorizedIosApp } = useIsMobileApp();

  const { pathname } = useLocation();
  const { sport, generateSportContextPath } = useSportContext();
  const isPrimary = matchAnySportPath(
    ANY_SPORT_MARKET_AUCTIONS,
    pathname,
    sport
  );

  const to = isPrimary
    ? generateSportContextPath(ANY_SPORT_MARKET_MANAGER_SALES)
    : generateSportContextPath(ANY_SPORT_MARKET_AUCTIONS);

  const linkMessage = isPrimary ? messages.goToSecondary : messages.goToPrimary;
  if (isIosApp && !isMarketAuthorizedIosApp) return null;
  return (
    <CTA size="medium" to={to} color="primary">
      {ctaMessage || <FormattedMessage {...linkMessage} />}
    </CTA>
  );
};
